var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"image"},[_c('skeleton-loader',{attrs:{"type":"image","loading":""}})],1),_c('div',{staticClass:"rest"},[_c('skeleton-loader',{attrs:{"type":"list-item-three-line, card-heading, actions"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }